import React, { Component } from "react";
import withHOC from "../../../HOC/HOC";
import WhatsappMinimartList from "./WhatsappMinimartList";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { OPERATION_STATUS } from "../../../config/axios.init";
import Utility from "../../../utils/Utility";
import { getMinimartBusinessTypes } from "../../SuperDashBoard/SuperDashBoardAction";
import { BUSINESS_TYPE } from "../Constants";
import { getFilteredMinimartsWithWhatsAppDetails, sendBusinessInitiatedWhatsAppMessage } from "../WhatsappAction";
import { DEFAULT_PAGINATION_ACTIVE_PAGE, DEFAULT_PAGINATION_RECORDS_COUNT } from "../../CustomUIComponents/Pagination/PaginationConstants";
import LoadingModal from "../../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../../CustomUIComponents/UserNotification/UserNotification";
import { Strings } from "../../../resources/i18n/i18n";
class WhatsappMinimartListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            businessTypeList: BUSINESS_TYPE,
            minimarts: [],
            errorMessage: "",
            isSuccess: false,
            level: "",
            showLoader: "",
            toastMessage: ""

        }
    }
    componentDidMount() {
        this.props.getAllZones("SELLER");
        this.props.getAllZones("MESSENGER");
        this.getMinimartBusinessTypes();
    }

    handleOnClickSearchFilter = (searchFilterObject) => {
        this.setState({
            showLoader: true,
        });

        // Build reqObj similar to getMinimartDataAction
        let reqObj =
            Object.keys(searchFilterObject.search).length >= 1
                ? {
                    search: {
                        minimartName:
                            searchFilterObject.search.minimartName &&
                                searchFilterObject.search.minimartName !== ""
                                ? searchFilterObject.search.minimartName
                                : undefined,
                        ciId:
                            searchFilterObject.search.ciId &&
                                searchFilterObject.search.ciId !== ""
                                ? searchFilterObject.search.ciId
                                : undefined,
                        matricesId:
                            searchFilterObject.search.matricesId &&
                                searchFilterObject.search.matricesId !== ""
                                ? searchFilterObject.search.matricesId
                                : undefined,
                        type:
                            searchFilterObject.search.type &&
                                searchFilterObject.search.type !== ""
                                ? searchFilterObject.search.type
                                : undefined,
                        zone:
                            searchFilterObject.search.zone &&
                                searchFilterObject.search.zone !== ""
                                ? searchFilterObject.search.zone
                                : undefined,
                        messengerZone:
                            searchFilterObject.search.messengerZone &&
                                searchFilterObject.search.messengerZone !== ""
                                ? searchFilterObject.search.messengerZone
                                : undefined,
                        grade:
                            searchFilterObject.search.grade &&
                                searchFilterObject.search.grade !== ""
                                ? searchFilterObject.search.grade
                                : undefined,
                        supplierType:
                            searchFilterObject.search.supplierType &&
                                searchFilterObject.search.supplierType !== ""
                                ? searchFilterObject.search.supplierType
                                : undefined,
                        status:
                            searchFilterObject.search.minimartStatus &&
                                searchFilterObject.search.minimartStatus !== ""
                                ? searchFilterObject.search.minimartStatus
                                : undefined,
                        businessType: searchFilterObject.search.businessType
                            ? searchFilterObject.search.businessType
                            : undefined,
                        registrationStatus: searchFilterObject.search.registrationStatus
                            ? searchFilterObject.search.registrationStatus
                            : undefined,
                        level: searchFilterObject.search.level
                            ? searchFilterObject.search.level
                            : undefined,
                        zones: searchFilterObject.search.zones
                            ? searchFilterObject.search.zones
                            : undefined,
                        messengerZones: searchFilterObject.search.messengerZones
                            ? searchFilterObject.search.messengerZones
                            : undefined,
                        cedulaId: searchFilterObject.search.cedulaId
                            ? searchFilterObject.search.cedulaId
                            : undefined,
                        isScalaRegistered: searchFilterObject.search.isScalaRegistered,
                        subType: searchFilterObject.search.subType,
                        typeOfCustomer: searchFilterObject.search.typeOfCustomer
                            ? searchFilterObject.search.typeOfCustomer
                            : undefined,
                        whatsappUser: searchFilterObject.search.whatsappUser
                            ? searchFilterObject.search.whatsappUser
                            : undefined
                    },
                    limit: searchFilterObject.pagination.limit
                        ? searchFilterObject.pagination.limit
                        : DEFAULT_PAGINATION_RECORDS_COUNT,
                    offset:
                        searchFilterObject.pagination.offset - 1
                            ? searchFilterObject.pagination.offset - 1
                            : DEFAULT_PAGINATION_ACTIVE_PAGE - 1,
                }
                : {
                    search: {},
                    limit: searchFilterObject.pagination.limit
                        ? searchFilterObject.pagination.limit
                        : DEFAULT_PAGINATION_RECORDS_COUNT,
                    offset:
                        searchFilterObject.pagination.offset - 1
                            ? searchFilterObject.pagination.offset - 1
                            : DEFAULT_PAGINATION_ACTIVE_PAGE - 1,
                };

        getFilteredMinimartsWithWhatsAppDetails(
            reqObj,
            (responsedata) => {
                if (responsedata.status === OPERATION_STATUS.SUCCESS) {
                    const minimarts = responsedata.data.data.minimarts;
                    this.setState({
                        minimarts,
                        numberOfPages: responsedata.data.data.numberOfPages,
                        showLoader: false,
                        errorMessage: "",
                    });
                } else {
                    this.setState({
                        errorMessage: responsedata.error.message,
                        showLoader: false,
                    });
                }
            }
        );
    };

    getMinimartBusinessTypes = () => {
        this.setState({ showLoader: true });
        getMinimartBusinessTypes((response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                let list = Utility.createBusinessTypesList(
                    response.data.data.bty
                );
                this.setState({
                    businessTypeList: list,
                    showLoader: false,
                });
            } else {
                this.setState({
                    errorMessage: response.error.message,
                    showLoader: false,
                });
            }
        });
    };
    sendMessageToMinimarts = (reqObj, callBack, resetCheckbox) => {
        this.setState({
            showLoader: true,
            isSuccess: false,
            toastMessage: "",
        });
        sendBusinessInitiatedWhatsAppMessage(reqObj, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    toastMessage: Strings("successfullySent"),
                    showLoader: false,
                    isSuccess: true,
                    level: "success"
                }, () => {
                    callBack();
                    resetCheckbox();
                });
            } else {
                this.setState({
                    errorMessage: response.error.message,
                    toastMessage: response.error.message,
                    showLoader: false,
                    isSuccess: false
                }, () => {
                    callBack();
                });
            }
        })
    }
    render() {
        return (
            <>
                <LoadingModal showLoadingModal={this.state.showLoader} />
                {this.state.isSuccess && (
                    <UserNotification
                        key={this.state.toastMessage}
                        userNotificationObj={{
                            message: this.state.toastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                <WhatsappMinimartList
                    zones={this.props.zones}
                    mZones={this.props.mZones}
                    businessTypeList={this.state.businessTypeList}
                    rows={this.state.minimarts}
                    numberOfPages={this.state.numberOfPages}
                    errorMessage={this.state.errorMessage}
                    handleOnClickSearchFilter={this.handleOnClickSearchFilter}
                    sendMessageToMinimarts={this.sendMessageToMinimarts}
                />
            </>
        )
    }
}
const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
        },
        dispatch
    );
};
const WhatsappMinimartListWrapper = withHOC(WhatsappMinimartListContainer);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WhatsappMinimartListWrapper);